import { memo } from 'react'
import IconInformation from 'assets/information.svg?react'
import { IconTooltip, IIconTooltipProps } from 'shared/components/IconTooltip'

// eslint-disable-next-line
interface IProps extends Omit<IIconTooltipProps, 'Icon'> {}

export const IconTooltipInformation = memo<IProps>(function IconTooltipInformation(props) {
  return <IconTooltip {...props} Icon={IconInformation} />
})
